import React, { useCallback, useEffect } from 'react'
import { truncateFromCenter } from '../../helpers/sharedFunctions';
import { useWeb3Context } from '../../hooks/useWeb3Context';
import Button from '../Button/Button';

interface Props {
    disabled?: boolean;
    className?: string;
    style?: any;
    onClick: () => void
}

const ConnectButton: React.FC<Props> = (props) => {
    const { onClick, style, disabled, className }: Props = props;
    const { address, connect, connected, web3Modal, hasToSwitchNetwork, switchNetwork } = useWeb3Context();

    const hasCachedProvider = useCallback((): Boolean => {
        if (!web3Modal) return false;
        if (!web3Modal.cachedProvider) return false;
        return true;
    }, [web3Modal])

    useEffect(() => {
        if (hasCachedProvider()) connect();
    }, [hasCachedProvider, connect])

    return (
        <Button
            style={style}
            disabled={disabled}
            className={`${className ? className : 'button'}`}
            onClick={hasToSwitchNetwork ? switchNetwork : !connected ? connect : onClick}>
			<i className="fa-light fa-wallet"></i>
			<span>{hasToSwitchNetwork ? 'Switch network' : !connected ? 'Connect Wallet' : truncateFromCenter(address)}</span>
        </Button>)
}

export default ConnectButton;